import { openInNewTab } from '../../utils';

function pseudoLinksInit() {
  const pseudoLinks = document.querySelectorAll('[data-href]');

  Array.from(pseudoLinks).forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      window.location = link.getAttribute('data-href');
    });

    link.addEventListener('mousedown', e => {
      if (e.which === 2) openInNewTab(link.getAttribute('data-href'));
    });
  });
}

window.addEventListener('DOMContentLoaded', () => {
  pseudoLinksInit();
});
